/*@ngInject*/
const ClearReadySubmissionRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.markSubmissionClearReady = function (submissionId, reason, detail) {
        var url = '/rest/Submission/' + submissionId + '/markClearReady',
            config = {
                params: {
                    reason: reason,
                    detail: detail
                },
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };
        return this.post(url, {}, config);
    };
};

angular.module('gw-um-submission').service('clearReadySubmissionRepository', ClearReadySubmissionRepository);
